<template>
    <div>
        <StructuredData />
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-info shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--150" no-body>
                    <div class="px-4 py-5">
                        <div class="text-center mb-5">
                            <h1 class="display-3">Page Speed Optimierung</h1>
                            <p class="lead">
                                Schnellere Ladezeiten für bessere Rankings und mehr Conversions
                            </p>
                        </div>

                        <div class="row">
                            <div class="col-lg-8 mx-auto">
                                <h2>Warum ist Page Speed so wichtig?</h2>
                                <p>
                                    Die Ladegeschwindigkeit Ihrer Website ist ein entscheidender Ranking-Faktor bei Google. 
                                    Seit der Einführung der <strong>Core Web Vitals</strong> bewertet Google die Performance 
                                    Ihrer Seite noch genauer. Langsame Websites verlieren nicht nur Rankings, sondern auch Kunden: 
                                    <strong>53% der mobilen Nutzer</strong> verlassen eine Seite, die länger als 3 Sekunden lädt.
                                </p>

                                <div class="alert alert-info mt-4">
                                    <strong>Wussten Sie?</strong> Eine Verbesserung der Ladezeit um nur 0,1 Sekunden kann die 
                                    Conversion-Rate um bis zu 8% steigern (Google/Deloitte Studie).
                                </div>

                                <h3 class="mt-5">Unsere Page Speed Leistungen</h3>
                                
                                <div class="row mt-4">
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-info">
                                                    <icon name="ni ni-chart-bar-32" class="mr-2"></icon>
                                                    Performance Audit
                                                </h5>
                                                <p>
                                                    Umfassende Analyse mit Lighthouse, WebPageTest und Core Web Vitals. 
                                                    Identifikation aller Performance-Bottlenecks.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-success">
                                                    <icon name="ni ni-image" class="mr-2"></icon>
                                                    Bild-Optimierung
                                                </h5>
                                                <p>
                                                    WebP/AVIF-Konvertierung, Lazy Loading, responsive Images 
                                                    und automatische Komprimierung.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-warning">
                                                    <icon name="ni ni-archive-2" class="mr-2"></icon>
                                                    Code-Optimierung
                                                </h5>
                                                <p>
                                                    Minifizierung, Tree Shaking, Code Splitting und 
                                                    Eliminierung von Render-Blocking Resources.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-primary">
                                                    <icon name="ni ni-world" class="mr-2"></icon>
                                                    Server & Caching
                                                </h5>
                                                <p>
                                                    CDN-Integration, Browser-Caching, GZIP/Brotli-Komprimierung 
                                                    und Server-Response-Optimierung.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                </div>

                                <h3 class="mt-5">Core Web Vitals optimieren</h3>
                                <p>
                                    Google bewertet Ihre Website anhand von drei Kernmetriken. 
                                    Wir optimieren alle drei für maximale Performance:
                                </p>
                                
                                <div class="row mt-4">
                                    <div class="col-md-4">
                                        <div class="text-center p-3 bg-gradient-success text-white rounded mb-3">
                                            <h4 class="text-white mb-0">LCP</h4>
                                            <small>Largest Contentful Paint</small>
                                        </div>
                                        <p class="text-center">
                                            Ladezeit des größten sichtbaren Elements. Ziel: unter 2,5 Sekunden.
                                        </p>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="text-center p-3 bg-gradient-warning text-white rounded mb-3">
                                            <h4 class="text-white mb-0">FID</h4>
                                            <small>First Input Delay</small>
                                        </div>
                                        <p class="text-center">
                                            Reaktionszeit auf erste Interaktion. Ziel: unter 100 Millisekunden.
                                        </p>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="text-center p-3 bg-gradient-info text-white rounded mb-3">
                                            <h4 class="text-white mb-0">CLS</h4>
                                            <small>Cumulative Layout Shift</small>
                                        </div>
                                        <p class="text-center">
                                            Visuelle Stabilität beim Laden. Ziel: unter 0,1.
                                        </p>
                                    </div>
                                </div>

                                <h3 class="mt-5">Technologien & Tools</h3>
                                <div class="mt-3">
                                    <badge type="info" rounded class="mr-2 mb-2">Lighthouse</badge>
                                    <badge type="info" rounded class="mr-2 mb-2">WebPageTest</badge>
                                    <badge type="info" rounded class="mr-2 mb-2">GTmetrix</badge>
                                    <badge type="info" rounded class="mr-2 mb-2">Core Web Vitals</badge>
                                    <badge type="info" rounded class="mr-2 mb-2">CDN</badge>
                                    <badge type="info" rounded class="mr-2 mb-2">Cloudflare</badge>
                                    <badge type="info" rounded class="mr-2 mb-2">Varnish</badge>
                                    <badge type="info" rounded class="mr-2 mb-2">Redis</badge>
                                </div>

                                <h3 class="mt-5">Unser Optimierungsprozess</h3>
                                <ul class="list-unstyled mt-3">
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>1. Analyse</strong> - Umfassender Performance-Audit Ihrer Website
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>2. Priorisierung</strong> - Identifikation der größten Performance-Gewinne
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>3. Optimierung</strong> - Umsetzung aller technischen Maßnahmen
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>4. Monitoring</strong> - Kontinuierliche Überwachung der Metriken
                                    </li>
                                </ul>

                                <div class="text-center mt-5">
                                    <base-button
                                        tag="a"
                                        href="/#kontakt"
                                        type="info"
                                        size="lg"
                                        icon="fa fa-envelope"
                                        @click.prevent="$router.push('/#kontakt')"
                                    >
                                        Kostenlose Performance-Analyse anfragen
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>

<script>
import StructuredData from '../components/StructuredData.vue'

export default {
    name: 'pagespeed',
    components: {
        StructuredData
    },
    head: {
        title: {
            inner: 'Page Speed Optimierung',
            separator: '|',
            complement: 'Web Services and More'
        },
        meta: [
            {
                name: 'description',
                content: 'Page Speed Optimierung DACH ✓ Core Web Vitals verbessern ✓ Lighthouse Score optimieren ✓ Schnellere Ladezeiten ✓ Bessere Google Rankings ✓ Jetzt Performance-Audit anfragen!',
                id: 'desc'
            },
            {
                name: 'keywords',
                content: 'Page Speed Optimierung, Core Web Vitals, Lighthouse Score, Website Performance, Ladezeit optimieren, LCP, FID, CLS, Website schneller machen, Performance Audit'
            },
            {
                property: 'og:title',
                content: 'Page Speed Optimierung | Web Services and More'
            },
            {
                property: 'og:description',
                content: 'Professionelle Page Speed Optimierung. Core Web Vitals verbessern, Lighthouse Score optimieren, schnellere Ladezeiten für bessere Rankings.'
            },
            {
                property: 'og:type',
                content: 'website'
            },
            {
                property: 'og:url',
                content: 'https://www.wsam.biz/page-speed-optimierung'
            },
            {
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                name: 'twitter:title',
                content: 'Page Speed Optimierung | Web Services and More'
            },
            {
                name: 'twitter:description',
                content: 'Core Web Vitals verbessern, Lighthouse Score optimieren, schnellere Ladezeiten für bessere Rankings.'
            }
        ]
    }
}
</script>
